export function isChromeBrowser() {
  const userAgent = navigator.userAgent || '';
  const vendor = navigator.vendor || '';

  if (/CriOS/i.test(userAgent)) {
    return true;
  }

  return /Chrome/i.test(userAgent)
    && /Google Inc/i.test(vendor)
    && !/Edg|OPR|Opera|SamsungBrowser|Firefox|FxiOS/i.test(userAgent);
}

export function openCurrentLinkInChrome() {
  const currentUrl = new URL(window.location.href);
  const path = `${currentUrl.host}${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`;

  if (/Android/i.test(navigator.userAgent || '')) {
    window.location.href = `intent://${path}#Intent;scheme=${currentUrl.protocol.replace(':', '')};package=com.android.chrome;end`;
    return;
  }

  if (/iPhone|iPad|iPod/i.test(navigator.userAgent || '')) {
    const chromeScheme = currentUrl.protocol === 'https:' ? 'googlechromes' : 'googlechrome';
    window.location.href = `${chromeScheme}://${path}`;
    return;
  }

  window.open(currentUrl.href, '_blank', 'noopener,noreferrer');
}
